const rtlLanguages = [
  'ar', // Arabic
  'he', // Hebrew
  'fa', // Persian
  'ur', // Urdu
  'ps', // Pashto
  'syr', // Syriac
  'dv', // Divehi
  'ku', // Kurdish (Sorani)
  'yi', // Yiddish
];

const useIsRtl = () => {
  const langCode = localStorage.getItem('language') || 'ar';
  return rtlLanguages.includes(langCode) ?? true;
};

export default useIsRtl;
